export const CUSTOM_LANGUAGE = 'customLanguage';
export const CUSTOM_BRAND = 'brand';
